import { string_to_slug } from '@helpers/constants';
import { IVehicleItem, IVehiclesCapacities } from '@helpers/types';
import { Divider, TextField, Typography } from '@mui/material';
import { useCallback } from 'react';

interface IVehiclesCapacitiesProps {
  hideTitle?: boolean;
  value: Partial<IVehiclesCapacities>;
  vehicles: Array<IVehicleItem>;
  onChange: (value: Partial<IVehiclesCapacities>) => void;
}

const VehiclesCapacities = (props: Partial<IVehiclesCapacitiesProps>) => {
  const { value, onChange } = props;

  const onChangeVehicles = useCallback(
    (something: Partial<IVehiclesCapacities>) => {
      if (onChange) {
        onChange({ ...value, ...something });
      }
    },
    [value, onChange],
  );

  if (!props.vehicles) return null;

  return (
    <div className="w-full flex flex-col gap-3">
      {!props.hideTitle && (
        <div className="flex flex-col gap-2">
          <Divider />
          <Typography variant="overline">
            Indique la cantidad de vehículos disponibles para todas las zonas
            elegidas
          </Typography>
        </div>
      )}
      <div className="flex flex-col gap-2">
        {props.vehicles.map((vehicle) => (
          <div
            key={`vehicle-${string_to_slug(vehicle.label)}`}
            className="flex items-center justify-between gap-4 py-2 px-3 rounded border border-gray-200"
          >
            <div className="flex items-center gap-2">
              <span className="text-gray-600">{vehicle.icon}</span>
              <Typography variant="body2" fontWeight="medium">
                {vehicle.label}
              </Typography>
            </div>
            <TextField
              variant="outlined"
              size="small"
              label="Unidades"
              className="w-28"
              value={value?.[vehicle.value as keyof IVehiclesCapacities] ?? 0}
              onChange={({ target: { value: val } }) => {
                let v: string = val.replace(/[^0-9]/g, '');
                if (v.length == 0) {
                  v = '0';
                }
                onChangeVehicles({ [vehicle.value]: parseInt(v) });
              }}
              inputProps={{ inputMode: 'numeric', pattern: '[0-9]*' }}
            />
          </div>
        ))}
      </div>
    </div>
  );
};

export { VehiclesCapacities };
